/** Values match backend `api.models.QcardLayoutVariant`. */
export const QcardLayoutVariant = {
  DEFAULT: "default",
  ACTION_FIRST: "action_first",
} as const;

export type QcardLayoutVariantValue =
  (typeof QcardLayoutVariant)[keyof typeof QcardLayoutVariant];

export function isActionFirstQcardLayout(
  variant: string | undefined | null
): boolean {
  return variant === QcardLayoutVariant.ACTION_FIRST;
}
